import { createSlice } from 'redux-starter-kit';
import apiClient from '../Api/api_client';
import { loadingSlice } from './LoadingStore';
import promotion_config from '../../promotion_config';

export const defaultEntryState = {
    entries: [],
    drawings: [],
    points: 0,
    last_entry: null,
    game_over: false,
    error: '',
};

// REDUCERS
// basic actions that affect this object only

const getEntriesReducer = (state, action) => {
    let ents = action.payload.entries.filter(ent => {
        return ent.game_id === promotion_config.promotion_id;
    });

    let points = ents.reduce((sum, val) => {
        return sum + parseInt(val.points);
    }, 0);

    return {
        ...state,
        entries: ents,
        points: points,
        drawings: action.payload.drawings,
    };
};

const resetReducer = (state, action) => {
    return {
        ...defaultEntryState,
    };
};

const setLastEntryReducer = (state, action) => {
    return {
        ...state,
        last_entry: action.payload,
    };
};

const clearErrorsReducer = (state, action) => {
    return {
        ...state,
    };
};

export const entrySlice = createSlice({
    name: 'entry',
    initialState: defaultEntryState,
    reducers: {
        getEntries: getEntriesReducer,
        reset: resetReducer,
        setLastEntry: setLastEntryReducer,
        clearErrors: clearErrorsReducer,
    },
});

//ACTUAL ACTIONS
// a place to make the actions more complex if necessary

const getEntries = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading());
    const result = await apiClient.getEntries();
    dispatch(entrySlice.actions.getEntries(result));
    dispatch(loadingSlice.actions.unsetLoading());
};

//actions that get exported to the views
export const entryActions = dispatch => {
    return {
        getEntries: payload => getEntries(dispatch, payload),
        reset: payload => dispatch(entrySlice.actions.reset(payload)),
        setLastEntry: payload =>
            dispatch(entrySlice.actions.setLastEntry(payload)),
        clearErrors: payload => dispatch(entrySlice.actions.clearErrors()),
    };
};
